/**
 * Format the given seconds to a hh:mm:ss format.
 * 
 * @param secString The seconds as a string.
 */
export function toHHMMSS(secString: string) {
  const sec_num = parseInt(secString, 10); // don't forget the second param
  const hours   = Math.floor(sec_num / 3600);
  const minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  const seconds = sec_num - (hours * 3600) - (minutes * 60);

  const hoursStr = hours < 10 ? `0${hours}` : `${hours}`;
  const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const secondsStr = seconds < 10 ? `0${seconds}` : `${seconds}`;
  return `${hoursStr}:${minutesStr}:${secondsStr}`;
}
